module.exports = __webpack_public_path__ + "assets/img/hguan.02594064.png";